<template>
  <b-modal id="bpjs-kesehatan-det" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal" >
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Registered Name</label>
                <div class="col-md-8 mb-3">
                  {{detail.name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Registered Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.registered_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Date</label>
                <div class="col-md-8 mb-3">
                  {{detail.birth_date}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Address</label>
                <div class="col-md-8 mb-3">
                  {{detail.address}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                    {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                    {{detail.status}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="cancel"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "BpjsKesehatanDetailForm",
  props:{
    data:{
      type:Object
    }
  },
  components:{
    BModal,
    BForm
  },
  data(){
    return {
      detail:{
        name:"",
        number:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if (this.data !== null){
          this.detail.number = this.data.number
          this.detail.name = this.data.name
          this.detail.registered_date = this.data.registered_date
          this.detail.birth_date = this.data.birth_date
          this.detail.address = this.data.address
          this.detail.desc = this.data.desc
          this.detail.status = this.data.status == 1 ? "Active" : "Not Active"
        }
      }, 100)
    },
    resetModal(){
      this.$parent.data = null
    },
    cancel(){
      this.$parent.data = null
      this.$refs.modal.hide()
    },
  }
}
</script>